import { render } from "./RandomPick.vue?vue&type=template&id=2393dc46&scoped=true"
import script from "./RandomPick.vue?vue&type=script&lang=js"
export * from "./RandomPick.vue?vue&type=script&lang=js"

import "./RandomPick.vue?vue&type=style&index=0&id=2393dc46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kevin\\Documents\\GitHub\\my_page\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2393dc46"]])

export default __exports__